export var startAnimation = 'inAnimation 1000ms ';
export var endAnimation = 'outAnimation 1010ms ';
export var dateFormat = 'DD.MM.YYYY HH:mm';
